export const CAPTION_HIGHLIGHT_EFFECTS = [
  'instant',
  'karaoke-fill',
  'karaoke-line-sweep',
] as const;

export type CaptionHighlightEffect = (typeof CAPTION_HIGHLIGHT_EFFECTS)[number];

export type CaptionKaraokeHighlightEffect = Extract<
  CaptionHighlightEffect,
  'karaoke-fill' | 'karaoke-line-sweep'
>;

export const CAPTION_HIGHLIGHT_EFFECT_OPTIONS = [
  { value: 'instant', label: '현재 단어 색상' },
  { value: 'karaoke-fill', label: '단어별 채우기' },
  { value: 'karaoke-line-sweep', label: '줄 단위 부드러운 채우기' },
] as const satisfies ReadonlyArray<{
  value: CaptionHighlightEffect;
  label: string;
}>;

const CAPTION_HIGHLIGHT_EFFECT_SET = new Set<string>(CAPTION_HIGHLIGHT_EFFECTS);

export const readCaptionHighlightEffect = (
  value: unknown,
): CaptionHighlightEffect =>
  typeof value === 'string' && CAPTION_HIGHLIGHT_EFFECT_SET.has(value)
    ? (value as CaptionHighlightEffect)
    : 'instant';

export const readCaptionHighlightEffectOrNull = (
  value: unknown,
): CaptionHighlightEffect | null =>
  typeof value === 'string' && CAPTION_HIGHLIGHT_EFFECT_SET.has(value)
    ? (value as CaptionHighlightEffect)
    : null;

export const isCaptionKaraokeHighlightEffect = (
  value: CaptionHighlightEffect | null | undefined,
): value is CaptionKaraokeHighlightEffect =>
  value === 'karaoke-fill' || value === 'karaoke-line-sweep';
